import React from 'react'

import { Modal, Button } from '_zari/core'

import TrazabilidadTimeline from 'sharedComponents/trazabilidad'

const TrazabilidadModal = ({ show, handleClose, idRequerimiento }) => {
  return (
    <Modal show={show} size='lg'>
      <Modal.Header>
        <Modal.Title>Trazabilidad del Requerimiento</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TrazabilidadTimeline idRequerimiento={idRequerimiento} />
      </Modal.Body>
      <Modal.Footer>
        <Button outline color='secondary' onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(TrazabilidadModal)
